import React from 'react';
import { globalHistory, Router } from '@reach/router';
import { QueryParamProvider } from 'use-query-params';
import Listing from './Listing';
import { useHabitat } from '@react/shared/HabitatContext';
const ListingRoot = () => {
    const { pageType, newsletterGuid, siteId, newsletterConfig, listNode, altFilter, filterDisabled, pagerDisabled, topN, } = useHabitat();
    return (React.createElement(QueryParamProvider, { reachHistory: globalHistory },
        React.createElement(Router, null,
            React.createElement(Listing, { default: true, pageType: pageType, newsletterGuid: newsletterGuid, siteId: siteId, newsletterConfig: newsletterConfig, listNode: listNode, altFilter: altFilter, filterDisabled: filterDisabled, pagerDisabled: pagerDisabled, topN: topN }))));
};
export default ListingRoot;
